import { IDsDoiTuongDuThiUpdateDuyetRequest } from "../../../model/request/tct/IDsDoiTuongDuThiUpdateDuyetRequest";
import { IDsDoiTuongDuThiViewModel } from "../../../model/respone/tct/IDsDoiTuongDuThiViewModel";
import { IDsDoiTuongDuThiReducerFilter } from "../../reducer-model/tct/IDsDoiTuongDuThiReducer";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eIDsDoiTuongDuThiActionsObj = {
    LOAD_START: 0,
    LOAD_SUCCESS: {} as IDsDoiTuongDuThiViewModel[],
    LOAD_ERROR: "",

    UPDATE_DUYET_START: {} as IDsDoiTuongDuThiUpdateDuyetRequest,
    UPDATE_DUYET_SUCCESS: undefined,
    UPDATE_DUYET_ERROR: "",

    CHANGE_FILTER: {} as IDsDoiTuongDuThiReducerFilter,
}

export const eIDsDoiTuongDuThiActionIds = generateActionTypeIds(eIDsDoiTuongDuThiActionsObj, "DOI_TUONG_DU_THI");
export type IDsDoiTuongDuThiActionTypes = IGenericActionType<typeof eIDsDoiTuongDuThiActionsObj, "DOI_TUONG_DU_THI">;